import produce from "immer";

import { React } from "xolabot-sdk";
import { store } from "../store";

export const BooleanAddon = ({ addon }) => {
    const { getState, setState } = store;
    const [quantity, setQuantity] = React.useState(0);

    const handleChange = (e) => {
        const { addons } = getState();
        setState({
            addons: produce(addons, (draft) => {
                const newQuantity = e.target.checked ? 1 : 0;
                draft[addon.id].quantity = newQuantity;
                setQuantity(newQuantity);
            }),
        });
    };
    return (
        <label>
            <input type="checkbox" onChange={handleChange} checked={quantity} /> Add to cart
        </label>
    );
};
